import { AcknowledgeMessageParams, AcknowledgeMessageResponse, MessageResponse } from '../models/notification-model';
import { getAsync, postAsync } from '../config/request/base-service';

/**
 * Fetch messages for a specific vendor user
 * @param vendorUserId - The vendor user ID
 * @param deviceToken - Device token for authentication
 * @returns Promise with array of messages
 */
export const fetchMessages = async (vendorUserId: number, deviceToken: string): Promise<MessageResponse[]> => {
  try {
    const headers = {
      deviceToken: deviceToken
    };

    const response = await getAsync<MessageResponse[]>(`/vendoruser/${vendorUserId}/messages`, undefined, headers);
    return response || [];
  } catch (error: any) {
    throw new Error(error.message || error.errorMessage || 'Failed to fetch messages');
  }
};

/**
 * Acknowledge a specific message
 * @param params - Object containing messageId, vendorAckBy, and deviceToken
 * @returns Promise with acknowledgment response
 */
export const acknowledgeMessage = async (params: AcknowledgeMessageParams): Promise<AcknowledgeMessageResponse> => {
  try {
    const { messageId, vendorAckBy, deviceToken } = params;

    const requestBody = {
      messageId,
      vendorAckBy
    };

    const headers = {
      deviceToken: deviceToken
    };

    const response = await postAsync<AcknowledgeMessageResponse>('/message/ack', requestBody, headers);

    // Check if response is successful
    if (response && (response.statusCode === 200 || response.statusCode === 204)) {
      return response;
    } else {
      throw new Error(response?.errorMessage || 'Failed to acknowledge message');
    }
  } catch (error: any) {
    throw new Error(error.message || error.errorMessage || 'Failed to acknowledge message');
  }
};
